import './App.css';
import './PageMarketingV2PresentFrame.css';

import TotemTV from './TotemTV';
import { TwitterPicker } from 'react-color';
import { Button } from 'primereact/button';
import { useState } from 'react';

function PageMarketingV2PresentFrame({ creativeURL }) {
    const [colorTotemTV, setColorTotemTV] = useState('brown');

    return (
        <div
            className='mk2-dark'
            style={{ padding: '1em' }}
        >
            <div className='mk2-title'>
                Framed TV
            </div>
            <div className='mk2-present-frame'>
                <div align='center'>
                    <TotemTV
                        color={colorTotemTV}
                        creativeURL={creativeURL}
                    />

                </div>
                <div
                    align='left'
                    className='mk2-present-frame-details'
                >
                    <div
                        className='mk2-subtitle-small'
                        align='justify'
                    >
                        Sleek and space-saving, our wall-mounted TV delivers immersive entertainment with a minimalist design, seamlessly blending technology and style.
                    </div>
                    <div className='mk2-mobile-hidden'>
                        <div style={{ marginTop: '1em' }}>
                            <TwitterPicker
                                color={colorTotemTV}
                                onChangeComplete={(color) => setColorTotemTV(color.hex)}
                                size='small'
                            />
                        </div>
                    </div>

                </div>
            </div>
            <div
                style={{ marginTop: '1em' }}
            >
                <div
                    className='mk2-subtitle'
                    style={{
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'center',
                    }}
                >
                    Starting from
                </div>
                <div className='mk2-title'>
                    9.9 EUR / month
                </div>
                <div>
                    <Button
                        label="View Offers"
                        severity="success"
                        outlined
                        size='small'
                    />
                </div>
            </div>
        </div>
    );
}

export default PageMarketingV2PresentFrame;